import { render } from "./DonutStatusChart.vue?vue&type=template&id=44d96e5b&ts=true"
import script from "./DonutStatusChart.vue?vue&type=script&lang=ts"
export * from "./DonutStatusChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__